import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiSmsHelperService {
  status = [
    { id: 'waiting', name: 'Non validé', color: 'primary' },
    { id: 'delivered', name: 'Validé', color: 'success' },
    { id: 'sent', name: 'Envoyé', color: 'info' },
    { id: 'error', name: 'Erreur', color: 'warn' },
  ];

  getStatusName(project: any) {
    let status = this.status.find((item) => item.id == project?.status);
    return status?.name || 'Inconnu';
  }

  getStatusColor(project: any) {
    let status = this.status.find((item) => item.id == project?.status);
    return status?.color || 'accent';
  }
}
